import * as React from 'react';

export const ArrowUpRight = ({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M10.8877 10.0875L10.9124 3.08747M10.9124 3.08747L3.91237 3.11217M10.9124 3.08747L3.08738 10.9125"
      stroke="currentColor"
      strokeMiterlimit="10"
    />
  </svg>
);

export const ChevronLeft = ({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M9 11L5 7L9 3"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronRight = ({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M5 3L9 7L5 11"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Chevron = ({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
    className={className}
    color="currentColor"
  >
    <path
      d="M19.8799 8.06055L11.9996 15.9407L4.11951 8.06055"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeMiterlimit="10"
    />
  </svg>
);

export const DropdownArrow = ({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <path
      d="M15.2148 9.75015L4.87891 9.74985V4.42969M15.2148 9.75015L11.6674 6.20287M15.2148 9.75015L11.6674 13.2971"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeMiterlimit="10"
    />
  </svg>
);
